import {useState, useCallback} from 'react';

export const useExpandableList = (itemsPerPage = 10) => {
	const [expandedLists, setExpandedLists] = useState({});

	const toggle = useCallback((key) => {
		setExpandedLists(prev => ({...prev, [key]: !prev[key]}));
	}, []);

	const reset = useCallback(() => {
		setExpandedLists({});
	}, []);

	const getVisibleItems = useCallback((key, items) => {
		if (!items || items.length === 0) return [];
		if (expandedLists[key] || items.length <= itemsPerPage) {
			return items;
		}
		return items.slice(0, itemsPerPage);
	}, [expandedLists, itemsPerPage]);

	const shouldShowMore = useCallback((items) => {
		return items && items.length > itemsPerPage;
	}, [itemsPerPage]);

	const isExpanded = useCallback((key) => {
		return expandedLists[key] || false;
	}, [expandedLists]);

	return {
		expandedLists,
		toggle,
		reset,
		getVisibleItems,
		shouldShowMore,
		isExpanded,
	};
};